
import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '@/components/SEO';

const NotFound = () => {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center p-4 text-center">
      <SEO 
        title="Sidan hittades inte - Frikopplad"
        description="Sidan du söker kan inte hittas. Gå tillbaka till startsidan för att fortsätta utforska Frikopplad."
        url="/404"
      />
      <h1 className="text-6xl font-bold text-frikopplad-navy mb-4">404</h1>
      <h2 className="text-2xl font-semibold text-gray-700 mb-6">Sidan hittades inte</h2>
      <p className="text-gray-600 mb-8 max-w-md">
        Sidan du söker finns inte eller har flyttats. Kontrollera URL:en eller återgå till startsidan.
      </p>
      <Link
        to="/"
        className="bg-frikopplad-navy hover:bg-frikopplad-burgundy text-white px-6 py-3 rounded-lg transition-colors"
      >
        Gå till startsidan
      </Link>
    </div>
  );
};

export default NotFound;
